module.exports = __webpack_public_path__ + "static/img/s1img1.af13147.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/s1img1.png
// module id = rNeL
// module chunks = 0